module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/trophy-brigade-lvl2-75.c346b058.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/trophy-brigade-lvl2-75.png
// module id = 3584
// module chunks = 11